import * as React from "react";

const Hourglass = (props: { color: string; className?: string }): JSX.Element => {
    return (
        <svg
            className={props.className}
            width="20"
            height="20"
            viewBox="0 0 12 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.89801 15.7051H10.0258C10.8796 15.7051 11.3902 15.2363 11.3902 14.3323V14.1147C11.3986 11.8044 8.93766 9.92939 7.85784 8.90821C7.55648 8.6236 7.39744 8.36414 7.39744 7.98746C7.39744 7.61078 7.55648 7.35967 7.85784 7.06667C8.92926 6.02874 11.3902 4.27092 11.3902 1.86856V1.66771C11.3902 0.763672 10.8796 0.294922 10.0258 0.294922H1.89801C1.06094 0.294922 0.600586 0.763672 0.600586 1.59235V1.86856C0.600586 4.27092 3.06151 6.02874 4.14134 7.06667C4.44266 7.35967 4.60169 7.61078 4.60169 7.98746C4.60169 8.36414 4.44266 8.6236 4.14134 8.90821C3.06151 9.92939 0.600586 11.8044 0.600586 14.1147V14.4076C0.600586 15.2363 1.06094 15.7051 1.89801 15.7051ZM2.76855 14.5583C2.36676 14.5583 2.24123 14.1147 2.63462 13.8217L5.49734 11.6872C5.58941 11.6119 5.63966 11.5617 5.63966 11.4361V7.40989C5.63966 6.95785 5.54759 6.73185 5.22948 6.46399C4.75237 6.06221 3.84837 5.42606 3.43819 4.84849C3.27076 4.61414 3.28751 4.4216 3.4968 4.4216H8.49401C8.70327 4.4216 8.72001 4.61414 8.55259 4.84849C8.14244 5.42606 7.2468 6.06221 6.7613 6.46399C6.44323 6.73185 6.35116 6.95785 6.35116 7.40989V11.4361C6.35116 11.5617 6.40137 11.6119 6.49344 11.6872L9.36451 13.8217C9.75794 14.1147 9.62401 14.5583 9.23062 14.5583H2.76855Z"
                fill={props.color}
            />
        </svg>
    );
};
export default Hourglass;
